var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-slider',_vm._b({ref:"slider",staticClass:"ds-vue-slider",model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}},'vue-slider',_vm.options,false))}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c35f467","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!../panel-theme/src/js/widgets/ds-slider.vue
// module id = null
// module chunks = 